import { strings } from 'strings'

export const getHelperText = (label: string, select?: boolean) =>
  `${label} ${select ? strings.selectHelperText : strings.helperText}`

export const getLatLngFromNmea = (nmea: string[]) => {
  if (!nmea) return

  // const parts = nmea.split(',')

  const lat = nmea[2]
  const latDir = nmea[3]

  const lng = nmea[4]
  const lngDir = nmea[5]

  if (!lat || !latDir || !lng || !lngDir) return

  const latDegress = parseInt(lat.slice(0, 2), 10)
  const latMinutes = parseFloat(lat.slice(2))
  let latDecimalDegrees = latDegress + latMinutes / 60
  if (latDir === 'S') latDecimalDegrees *= -1

  const lngDegress = parseInt(lng.slice(0, 3), 10)
  const lngMinutes = parseFloat(lng.slice(3))
  let lngDecimalDegrees = lngDegress + lngMinutes / 60
  if (lngDir === 'W') lngDecimalDegrees *= -1

  return [latDecimalDegrees, lngDecimalDegrees]
}

export const generateExportFileName = (mountpointName: string | undefined, format: string) => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  
  return `${mountpointName}_${format}_${year}-${month}-${day}_${hour}-${minute}-${second}`
}
